import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const batchLabel = {
  id: 'batch-labels',

  getDocumentRequestNotificationProps: (docCount, selectedPrinterName) => ({
    title: <FormattedMessage {...messages.printingLabelTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.sentToPrinter} values={{ selectedPrinterName }} />,
  }),
};
